export default{
	mboptions:[
		{
			label:"标准模板",
			value:"0"
		},
		{
			label:"自定义模板",
			value:"1"}
	],
	typeing:[
		{
			label:"增值税",
			value:"0"
		},{
			label:"普通发表",
			value:"1"
		},{
			label:"专用发票",
			value:"2"
		},

	]
}